import React from 'react';
import Title from '../partials/title';
import Card from './partials/card';
import { Link } from 'react-router';
import { Animated } from "react-animated-css";
import _ from 'lodash';

// August 6th: Refactored for Responsiveness
// TODO: What happens when there are no 'upcoming' events
class Upcoming extends React.Component {
    componentWillMount() {
        const { tournamentsActions } = this.props;
        tournamentsActions.fetchUpcoming();
    }
    render() {
        const { className, upcoming } = this.props;
        return upcoming && upcoming.length > 0 ? (<Animated animationIn="fadeIn" className={`${className} w3-container w3-content pb-8 pt-8`}>
            <Title text="UPCOMING TOURNAMENTS" />
            {upcoming && upcoming.length > 0 && <div className="d-flex row-into-column margin-top-double">
                {_.take(upcoming, 3).map((t, index) => <Card key={index} index={index} tournament={t} total={upcoming.length >= 3 ? 3 : upcoming.length} />)}
            </div>}
            <div className="d-flex flex-row justify-content-center margin-top-double">
                <Link to="/tournaments" className="w3-button w3-theme margin-top w3-center">VIEW ALL{upcoming && upcoming.length > 0 ? '' : ' PREVIOUS '}TOURNAMENTS</Link>
            </div>
        </Animated>) : (<div style={{ height: 400 }} />)
    }
}

export default Upcoming;



// WEBPACK FOOTER //
// ./src/components/tournaments/upcoming.js